import env from '@/config/env'
import request from '@/router/axios'
/**
 * 司机运营数据-地图版 start
 */
// 通过地级归属查站点列表
export const getStationListByManageId = (data) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/stationList/${data.areaManageId}`,
    method: 'POST'
  })
}
// 查询司机运营数据
export const getDriverOperation = (data) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/driver-operation',
    method: 'POST',
    timeout: 30000,
    data
  })
}

// 订单明细
export const getOrderInfo = (data) => {
  return request({
    url: env.ferryUrl + `/platform-date-analysis/order/${data.orderId}`,
    method: 'GET'
  })
}

// 司机明细
export const getDriverInfo = (data) => {
  return request({
    url: env.ferryUrl + `/platform-date-analysis/driver/${data.driverId}`,
    method: 'GET'
  })
}

// 派单司机明细
export const getDispatchDriverInfo = (params) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/dispatch-driver',
    method: 'GET',
    params
  })
}

// 根据城市code获取地级归属
export const getDefaultAreamanage = (params) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/default-areamanage',
    method: 'GET',
    params
  })
}

/**
 * 司机运营数据-地图版 end
 */
